<div class="default-layout">
  <app-header></app-header>
  <main class="default-layout__content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
  <app-toast></app-toast>
</div>
